import React from 'react';
import { Dropdown } from 'reactstrap';
import {
  CountryBox,
  DropdownToggleCustom,
  DropdownMenuCustom,
  DropdownItemCustom,
  FlagImage,
  AngleDownIcon,
  CountryButton,
} from './styles';
import { useLanguageContext } from '../../../../contexts/LanguageContext';

const Country = ({
  country,
  index,
  regionIndex,
  dropdownOpen,
  selectedCountryIndex,
  selectedRegionIndex,
  handleDropdownToggle,
  handleMenuVisibility,
  currentCountry,
}) => {
  const { setLanguage } = useLanguageContext();

  return (
    <CountryBox data-id="country-box" active={currentCountry === country.shortName}>
      {country.languages.length > 1 ? (
        <Dropdown
          isOpen={
            dropdownOpen && index === selectedCountryIndex && regionIndex === selectedRegionIndex
          }
          toggle={() => handleDropdownToggle(index)}
        >
          <DropdownToggleCustom data-id="language-selector">
            { country?.image && <FlagImage src={`/flags/${country.image}`} />}
            {`${country.name}/${country.languages[0].title}`}
            <AngleDownIcon className="dds__icons">〉</AngleDownIcon>
          </DropdownToggleCustom>
          <DropdownMenuCustom>
            {country.languages.map((language, index) => (
              <DropdownItemCustom
                key={index}
                data-id="language-dropdown-item"
                onClick={() => {
                  setLanguage({
                    locale: language.locale,
                  });
                  handleMenuVisibility();
                }}
              >
                {`${country.name}/${language.title}`}
              </DropdownItemCustom>
            ))}
          </DropdownMenuCustom>
        </Dropdown>
      ) : (
        <CountryButton
          data-id="country-button"
          onClick={() => {
            setLanguage({
              locale: country.languages[0].locale,
            });
            handleMenuVisibility();
          }}
        >
          {country?.image && <FlagImage src={`/flags/${country.image}`} />}
            {`${country.name}/${country.languages[0].title}`}
        </CountryButton>
      )}
    </CountryBox>
  );
};

export default Country;
